import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import {
  SvgCalendar3,
  SvgCheveronDown,
  SvgCheveronRight,
  SvgCog,
  SvgCreditCard,
  SvgReports,
  SvgStoreFront,
  SvgTag,
  SvgTuning,
  SvgWallet,
} from '@/components/icons';
import { Item } from './Item';

const MORE_ROUTES = ['/payees', '/rules', '/bank-sync', '/tags', '/settings'];

/**
 * Direct port of `sidebar/PrimaryButtons.tsx`: Budget, Reports, Schedules and
 * an expandable "More" group that auto-opens while any child route is active.
 */
export function PrimaryButtons() {
  const location = useLocation();
  const [isOpen, setOpen] = useState(false);
  const isActive = MORE_ROUTES.some(route =>
    location.pathname.startsWith(route),
  );

  useEffect(() => {
    if (isActive) setOpen(true);
  }, [isActive]);

  return (
    <nav className="shrink-0" data-testid="sidebar-primary-buttons">
      <Item title="预算" Icon={SvgWallet} to="/budget" />
      <Item title="报表" Icon={SvgReports} to="/reports" />
      <Item title="周期账单" Icon={SvgCalendar3} to="/schedules" />
      <Item
        title="更多"
        Icon={isOpen ? SvgCheveronDown : SvgCheveronRight}
        onClick={() => setOpen(value => !value)}
        forceActive={!isOpen && isActive}
      />
      {isOpen && (
        <div className="mt-[5px]">
          <Item title="收款人" Icon={SvgStoreFront} to="/payees" indent={15} />
          <Item title="规则" Icon={SvgTuning} to="/rules" indent={15} />
          <Item
            title="银行同步"
            Icon={SvgCreditCard}
            to="/bank-sync"
            indent={15}
          />
          <Item title="标签" Icon={SvgTag} to="/tags" indent={15} />
          <Item title="设置" Icon={SvgCog} to="/settings" indent={15} />
        </div>
      )}
    </nav>
  );
}
